import { useEffect, useMemo, useState } from 'react'

import { useGet } from '../../../../hooks/apiHooks'
import { config } from '../../../Init/Init'
import { tokenizer } from '../../../../services/utils'
import { usePlayerStore } from '../../../../services/store'
import { useCryptoPaymentModal } from '../../CryptoPaymentModalProvider'

export const useGetLastPurchasedCryptoCurrency = () => {
  const playerStore = usePlayerStore()
  const playerLoginUser = playerStore.use.loginUser()

  const { isCryptoPaymentModalOpen } = useCryptoPaymentModal()

  const [lastPurchasedCryptoCurrencyData, setLastPurchasedCryptoCurrencyData] = useState({
    completedPurchasesExist: false,
    cryptoCurrency: ''
  })
  const { GET, isLoading, isDone } = useGet()

  const transactionsPath = useMemo(() => {
    return (
      config.apiUrl +
      tokenizer(config.getLastPurchaseCryptoUrl, {
        '{userId}': playerLoginUser.userId
      })
    )
  }, [playerLoginUser.userId])

  useEffect(() => {
    if (isCryptoPaymentModalOpen && !isDone) {
      GET(transactionsPath).then(data => setLastPurchasedCryptoCurrencyData(data))
    }
  }, [isCryptoPaymentModalOpen])

  return {
    lastPurchasedCryptoCurrencyData,
    isGetLastPurchasedCryptoCurrencyLoading: isLoading,
    isGetLastPurchasedCryptoCurrencyDone: isDone
  }
}
